
export default "/assets/device-phone-mobile-micro.69b00672.svg"